import type { FC } from 'react';
import { useEffect } from 'react';

import { Skeleton } from '@cognite/cogs-core-v11/components/skeleton/skeleton.tsx';
import { useAuthContext } from '@cognite/e2e-auth';

import { useIsAppConfiguratorQuery } from '../app-config/hooks/use-query/use-is-app-configurator-query';

import { ConfigView } from './config-view';

export const IdmConfigPage: FC = () => {
  const { authState } = useAuthContext();
  const { data: hasAppConfigPermission, isLoading } =
    useIsAppConfiguratorQuery();

  const org = authState?.projectInfo.org;
  const project = authState?.projectInfo.id;
  const cluster = authState?.projectInfo.cluster.apiBaseURL?.replace(
    'https://',
    ''
  );

  useEffect(() => {
    if (!isLoading && !hasAppConfigPermission) {
      if (org && project && cluster) {
        window.location.href = `https://${org}.fusion.cognite.com/${project}?cluster=${cluster}`;
      } else {
        window.location.href = `https://fusion.cognite.com`;
      }
    }
  }, [cluster, hasAppConfigPermission, isLoading, org, project]);

  if (isLoading) {
    return <Skeleton.List />;
  }

  if (hasAppConfigPermission) {
    return <ConfigView />;
  }

  return <div>Redirecting to Fusion...</div>;
};
